<!--
 * @Author: mzw
 * @Date: 2021-09-26 10:45:17
 * @LastEditors: mzw
 * @LastEditTime: 2021-10-22 11:07:32
 * @Description: 进度条组件
-->
<template>
    <div :class="['progress-bar',`${themeColor}-bar`]">
        <span class="bar-title">{{barTitle}}</span>
        <ul>
            <li v-for="(item,index) in progressList"
                :key="item.key">
            <span>{{item.title}}</span>
            <div :class="['bar-status ', item.status=='unfinished'?'unfinished':'']">
                <span v-if="item.status=='finished'"><i class="el-icon-check"></i></span>
                <!-- <span v-else-if="item.status=='current'">...</span> -->
                <span v-else-if="item.status=='unfinished'">{{index+1}}</span>
            </div>
            <span class="time" v-if="item.time">{{item.time}}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    progressList: {
      type: Array,
      default: () => {
        return []
      }
    },
    themeColor: {
      type: String
    },
    barTitle: {
      type: String
    }
  },
  methods: {}
}
</script>
<style lang='scss' scoped>
.progress-bar{
  display: flex;
  align-items: center;
  // 蓝色进度条
  &.blue-bar{
    .bar-title{
      color: #3D88D4;
    }
    &>ul{
      li{
        .bar-status{
          &::before{
            background: #3D88D4;
          }
          &>span{
            border: 4px solid #85C2FA;
            background: #3D88D4;
          }
        }
      }
    }
  }
  // 橙色进度条
  &.orange-bar{
    .bar-title{
      color: #EC7604;
    }
    &>ul{
      li{
        .bar-status{
          &::before{
            background: #EC7604;
          }
          &>span{
            border: 4px solid #FFBE7F;
            background: #EC7604;
          }
        }
      }
    }
  }
  .bar-title{
    font-size: 16px;
    margin-right: 15px;
  }
  &>ul{
    display: flex;
    align-items: flex-start;
    li{
      width: 129px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      &>span{
        line-height: 30px;
      }
      &>span.time{
        font-size: 12px;
      }
      .bar-status{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &::before{
          content: '';
          width: 100%;
          height: 2px;
          display: block;
          position: absolute;
          left:0;
          top:50%;
          transform: translateY(-50%);
        }
        &>span{
          width: 28px;
          height: 28px;
          border-radius: 14px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        // 未进行样式
        &.unfinished{
          &::before{
            background: #DCDCDC;
          }
          &>span{
            border: 4px solid #DCDCDC;
            background: #D2D1D1;
          }
        }
      }
    }
  }
}
</style>
